// extracted by mini-css-extract-plugin
export var caretAnchor = "_uj-0";
export var dropdownContent = "_uj-1";